import axiosInstance from '../../axiosInstance';

import { ICrystalsData } from './types';

export const getCrystalsData = async (token: string): Promise<ICrystalsData> => {
  const response = await axiosInstance.get<ICrystalsData>('/crystals/my?language_code=ru', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
